import { CSSProperties } from 'react';

export const logoStyle: CSSProperties = {
  height: '120px',
  padding: '12px 0px',
};
